var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v(" Validación de trámite "),_c('i',{staticClass:"fa fa-certificate",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }